import { render, staticRenderFns } from "./editor-field.vue?vue&type=template&id=65f0720c&"
import script from "./editor-field.vue?vue&type=script&lang=js&"
export * from "./editor-field.vue?vue&type=script&lang=js&"
import style0 from "./editor-field.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports